<div class="table-custom tcp"
     *ngIf="tableContent"
     [ngClass]="tableContent.class ? tableContent.class : ''">

  <div class="table-custom__title"
       fxLayout="row layout-wrap"
       fxLayout.xs="column"
       fxLayoutAlign="space-between center">
    <div fxFlex="50%"
         fxFlex.xs="100%"
         fxLayout.xs="column"
         class="table-custom__title-text">
      <span class="table-custom__title-text w-100 d-block"
            *ngIf="tableContent.title">{{tableContent.title}}</span>
      <span class="w-100 d-block"
            *ngIf="tableContent.subTitle">{{tableContent.subTitle}}</span>
    </div>

    <div fxFlex="50%"
         fxFlex.xs="100%"
         fxLayout.xs="column"
         fxLayoutAlign="end center"
         ngClass.xs="w-100"
         class="table-custom__title-right"
         *ngIf="displayFilter">
      <app-filter-chip class="w-100"
                       ngClass.gt-xs="mr-2">
      </app-filter-chip>
      <ng-content> </ng-content>
    </div>
  </div>

  <div class="loading-div w-100"
       *ngIf="loading"
       fxLayout="row"
       fxLayoutAlign="center center"
       [ngStyle]="tableContent.pageSize == 25 ? {'height': '500px'} : {'height': '300px'}">
    <mat-spinner diameter="40"
                 color="primary-light"
                 class="m-auto"></mat-spinner>
  </div>

  <div class="table-custom__box">
    <table #table
           mat-table
           matTableResponsive
           multiTemplateDataRows="expansive"
           [ngStyle]="tableContent.width ? { 'width': tableContent.width } : { 'width': '100%' }"
           [ngClass]="{'table-custom__hidden' : loading}"
           [dataSource]="filtereItens">

      <ng-container matColumnDef="{{itemColumn}}"
                    *ngFor="let itemColumn of tableContent.columns">

        <th mat-header-cell
            *matHeaderCellDef>{{ tableContent.columnData[itemColumn].header | uppercase }}</th>

        <td mat-cell
            *matCellDef="let itemDataSource">

          <ng-container *ngIf="tableContent.columnData[itemColumn].type === tableColumnTypeEnum.CHECKBOX">
            <mat-checkbox color="primary"
                          [value]="itemDataSource[tableContent.columnData[itemColumn].element]">
            </mat-checkbox>
          </ng-container>

          <ng-container *ngIf="tableContent.columnData[itemColumn].type === tableColumnTypeEnum.CUSTOM">
            <ng-container
                          *ngTemplateOutlet="customCell; context:{$implicit: { element: itemDataSource, object: tableContent.columnData[itemColumn]  }}">
            </ng-container>
          </ng-container>

          <ng-container *ngIf="tableContent.columnData[itemColumn].type === tableColumnTypeEnum.STRING">
            <ng-container *ngIf="tableContent.columnData[itemColumn].pipe; else noPipe">
              <app-table-pipes [pipe]="tableContent.columnData[itemColumn].pipe"
                               [value]="itemDataSource[tableContent.columnData[itemColumn].element]">
              </app-table-pipes>
            </ng-container>

            <ng-template #noPipe>
              <ng-container *ngIf="!!tableContent.columnData[itemColumn].transformData; else styleCustom">
                <span>
                  {{ tableContent.columnData[itemColumn].transformData(itemDataSource) }}
                </span>
              </ng-container>

              <ng-template #styleCustom>
                <ng-container *ngIf="!!tableContent.columnData[itemColumn].styleCustom; else noTransform">
                  <span [ngClass]="tableContent.columnData[itemColumn].styleCustom(itemDataSource)">
                    {{itemDataSource[tableContent.columnData[itemColumn].element] ? itemDataSource[tableContent.columnData[itemColumn].element] : '-' }}
                  </span>
                </ng-container>
              </ng-template>

              <ng-template #noTransform>
                <span>
                  {{itemDataSource[tableContent.columnData[itemColumn].element] ? itemDataSource[tableContent.columnData[itemColumn].element] : '-' }}
                </span>
              </ng-template>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="tableContent.columnData[itemColumn].type === tableColumnTypeEnum.OBJECT">
            <ng-container *ngIf="tableContent.columnData[itemColumn].pipe; else noPipe">
              <app-table-pipes [pipe]="tableContent.columnData[itemColumn].pipe"
                               [value]="getFromObject(itemDataSource, tableContent.columnData[itemColumn].element)">
              </app-table-pipes>
            </ng-container>
            <ng-template #noPipe>
              <span>
                {{getFromObject(itemDataSource, tableContent.columnData[itemColumn].element) == '' ? '-' :
                getFromObject(itemDataSource, tableContent.columnData[itemColumn].element) }}
              </span>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="tableContent.columnData[itemColumn].type === tableColumnTypeEnum.SINGLE_BUTTON">
            <app-single-buttons [type]="tableContent.columnData[itemColumn].buttonType"
                                [buttons]="tableContent.columnData[itemColumn].buttons"
                                [itemDataSource]="itemDataSource">
            </app-single-buttons>
          </ng-container>

          <ng-container *ngIf="tableContent.columnData[itemColumn].type === tableColumnTypeEnum.GROUP_BUTTONS">
            <app-group-buttons [buttons]="tableContent.columnData[itemColumn].buttons"
                               [itemDataSource]="itemDataSource">
            </app-group-buttons>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail"
                    *ngIf="expansive">
        <td mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length">
          <div class="element-detail"
               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">

            <app-table-custom [tableData]="tableExpansiveContent"
                              [dataExpanded]="element[tableContent.elementExpansionDataTable]"
                              class="pt-2 mt-2 table w-100">
            </app-table-custom>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="!expansive">
        <tr mat-header-row
            *matHeaderRowDef="displayedColumns;  sticky: true"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns;"></tr>
      </ng-container>

      <ng-container *ngIf="expansive">
        <tr mat-header-row
            *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
            *matRowDef="let element; columns: displayedColumns;"
            class="element-row"
            [class.expanded-row]="expandedElement === element || selectedItem === expandedElement"
            (click)="expandedElement = expandedElement === element ? null : element;">
        </tr>
        <tr mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="detail-row">
        </tr>
      </ng-container>
    </table>
  </div>

  <div class="loading-div w-100"
       *ngIf="(!items || items.length == 0) && !loading"
       fxLayout="row"
       fxLayoutAlign="center center"
       [ngStyle]="tableContent.pageSize == 25 ? {'height': '500px'} : {'height': '300px'}">
    <div class="txt-center">
      Não existe dados para serem exibidos.
    </div>
  </div>

  <mat-paginator [length]="length"
                 [pageSize]="tableContent.pageSize"
                 [ngStyle]="{'display: none': !displayPaginator}"
                 [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
</div>
